import styled from '@emotion/styled'
import CheckboxField from '../CheckboxField'
import { getBodyFonts } from 'css/theme'
import { forwardRef } from 'react'
import { useTranslation } from 'next-i18next'

interface WaiverFieldProps {
  id: string | number
  label: string
  error?: { message: string }
  maxLength?: number
  required: boolean
  value?: string
  dataId?: string
  autoFocus?: boolean
}

const WaiverField = forwardRef<HTMLInputElement, WaiverFieldProps>(
  ({ id, label, error, required, dataId, autoFocus }, ref) => {
    const { t } = useTranslation('common')

    return (
      <WaiverWrapper>
        <WaiverLabel>{label}</WaiverLabel>
        <CheckboxField
          id={`${id}`}
          error={error}
          required={required}
          dataId={dataId}
          ref={ref}
          autoFocus={autoFocus}
        >
          {t('WaiverField.agreementCheckbox.label', 'I accept the Waiver Agreement')}
        </CheckboxField>
      </WaiverWrapper>
    )
  },
)

WaiverField.displayName = 'WaiverField'

export default WaiverField

const WaiverWrapper = styled.div``

const WaiverLabel = styled.div({
  maxHeight: '340px',
  overflowY: 'auto',
  width: '100%',
  borderRadius: 8,
  marginBottom: 8,
  padding: '8px 12px',
  border: '1px #857f7a solid',
  ...getBodyFonts(),
})
